import { ManagedUserGroupIntegrationType } from "types/generated";

export const commonDefaultValues = {
  integrationType: ManagedUserGroupIntegrationType.Slack,
  name: "",
  spaces: [{ space: undefined, spaceAccessLevel: undefined }],
};

export const GRANT_SLACK_ACCESS_DRAWER_TEST_ID = "grant-slack-access-drawer";
